import Api from '../../helpers/api';
import Locations from '../../helpers/locations';
import Constants from './DoctorConfirmationConstant';

export const getDoctorAssinged = (parsed, id) => {

    if (parsed?.add) {
        var params = {
            add : parsed?.add
        }
    } else {
        params = {}
    }

    let location = `${Locations.doctorBooking}${id}/`

    return function (dispatch) {

        const successCall = (response) => {
            dispatch({
                type: Constants.ACTIONS.GET_DOCTOR_ASSINGED,
                payload: response
            });
        };

        const errorCall = (errorResponse) => {
            console.log(errorResponse)
            dispatch({
                type: Constants.ACTIONS.GET_DOCTOR_ASSINGED_FAILED,
                payload: errorResponse
            });
        }

        Api.doGet(location, params, successCall, errorCall);
    }
}

export default {
    getDoctorAssinged
}